import { createApp } from 'vue';
import { createMetaManager } from 'vue-meta';
import App from './App.vue';
import router from './router';
import store from './store/index';
import axios from 'axios';
import moment from 'moment';
import { BASE_URL } from './constants';

import { createI18n } from 'vue-i18n';
import ar from '@/i18n/ar';
import en from '@/i18n/en';
import rAr from '@/i18n/rules/ar';
import rEn from '@/i18n/rules/en';

const i18n = createI18n({
	locale: 'ar',
	fallbackLocale: 'ar',
	legacy: false,
	messages: {
		ar: { ...ar, rp: rAr },
		en: { ...en, rp: rEn },
	},
});

window.moment = moment;
window.moment.locale('ar-sy', {
	months: [
		'كانون الثاني',
		'شباط',
		'آذار',
		'نيسان',
		'أيار ',
		'حزيران',
		' تموز',
		' آب',
		' أيلول',
		' تشرين الأول',
		' تشرين الثاني',
		' كانون الأول',
	],
});
window.axios = axios.create({
	baseURL: BASE_URL,
});
window.axios.defaults.headers.common['Accept-Language'] = 'ar';
// window.axios.interceptors.request.use(
// 	(config) => {
// 		console.log(i18n);
// 		config.headers['accept-language'] = i18n.locale;

// 		return config;
// 	},
// 	(err) => {
// 		return Promise.reject(err);
// 	},
// );

createApp(App).use(i18n).use(store).use(router).use(createMetaManager()).mount('#app');
